import React from "react";
import './ValidationButton.css';
import {Button} from "@mui/material";
import {Check} from "@mui/icons-material";
import { withTranslation, WithTranslation } from 'react-i18next';

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Function called when the button is clicked.
     */
    onClick?: () => void,
    /**
     * Button id.
     */
    id?: string,
    /**
     * Button class name.
     */
    className?: string
}

/**
 * Standard validation button for the application.
 * @author Alizée Grand
 * @version 1.0
 * @creation 19/04/2022
 * @last_update 19/04/2022
 **/
class ValidationButton extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (
            <Button
                variant="contained"
                color="success"
                onClick={this.props.onClick}
                id={this.props.id}
                className={this.props.className + " validation-button"}
                size="large"
                endIcon={<Check/>}
            >
                {
                    getTranslation('utils.button.validate.content')
                }
            </Button>
        );
    };

}

export default withTranslation()(ValidationButton);
